import {Component} from '@angular/core';

@Component({
  selector: 'pt-no-available-comments',
  template: `
    <div class='alert alert-warning'>
      {{'MESSAGE.NO_AVAILABLE_COMMENTS' | translate}}
    </div>
  `
})
export class NoAvailableCommentComponent {

}
